export default {
    namespaced: true,
    state: {
      authorities: [
        {
          id: 100,
          name: 'Finanzamt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 101,
          name: 'Abfllwirtschafts- und Stadtreinigungsbetrieb',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 102,
          name: 'Bürgeramt Stadtmitte',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 103,
          name: 'Bürgeramt Lechhausen',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 104,
          name: 'Amt für Kinder, Jugend & Familie',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 105,
          name: 'Amt für Brand- und Katastrophenschutz',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 106,
          name: 'Amt für Verbraucherschutz',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 107,
          name: 'Amt für Wohnungswesen',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 108,
          name: 'Bürgeramt Kriegshaber',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 109,
          name: 'Agentur für Arbeit',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 110,
          name: 'Ausländerbehörde',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 111,
          name: 'Stadtwerke Augsburg',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 112,
          name: 'Kulturamt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 113,
          name: 'Kulturreferat',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 114,
          name: 'Kämmerei- & Steueramt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 115,
          name: 'Veterinäramt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 116,
          name: 'Wirtschafts & Finanzreferat',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 117,
          name: 'Wohnungs- & Stiftungsamt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 118,
          name: 'Schulverwaltungsamt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 119,
          name: 'Standesamt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 120,
          name: 'Stadtplanungsamt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 121,
          name: 'Landratsamt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
        {
          id: 122,
          name: 'Hauptzollamt',
          contactPerson: 'Peter Plätzold',
          icon: '',
          adress: '',
          services: [100, 101, 102, 103],
        },
      ]
    },
    mutations: {

    },
    actions: {

    },
    getters: {
      getAllAuthorities: state => {
        return state.authorities;
      },
      getAuthorityById: (state) => (id) => {
        return state.authorities.find(authority => authority.id == id)
      },
      getAuthoritiesByName: state => (searchTerm) => {
        return state.authorities.filter(authority => authority.name.toLowerCase().includes(searchTerm.toLowerCase()));
      }
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/authorities.js